import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { routeAnimation } from '@wm-libs/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';

@Component({
  selector: 'app-dashboard-layout',
  templateUrl: './dashboard-layout.component.html',
  styleUrls: ['./dashboard-layout.component.scss'],
  animations: [routeAnimation],
  standalone: true,
  imports: [
    MatSidenavModule,
    NgClass,
    SidebarComponent,
    RouterOutlet,
    AsyncPipe,
  ],
})
export class DashboardLayoutComponent implements OnInit {
  isMobile$ = this.breakpointObserver
    .observe([Breakpoints.XSmall, Breakpoints.Small])
    .pipe(map((result) => result.matches));

  constructor(private breakpointObserver: BreakpointObserver) {}

  animationEnabled = false;

  ngOnInit() {
    setTimeout(() => (this.animationEnabled = true), 0);
  }
}
